export const MODULE = 'BILLING_RPT';
export const UPLOAD = `${MODULE}/upload`;
export const LIST = `${MODULE}/list`;
export const UPLOAD_LIST = `${MODULE}/upload_list`;
export const SHOW_UPLOADED = `${MODULE}/show_uploaded`;
export const RPTAX_DOWNLOAD = "api/v1/administrators/file_uploads/{id}/download_failed";
export const DELETE_FILE_UPLOAD = "BILLINGS/delete_file_upload";
export const DELETE_FILE_HISTORY_UPLOAD = "BILLINGS/delete_file_history_upload";

export const CREATE_RECORD = "BILLINGS/create_record";
export const UPDATE_RECORD = "BILLINGS/update_record";

// for manual import (Smart City)
export const LIST_MANUAL_IMPORT = `${MODULE}/list_manual_import`;
export const CREATE_RECORD_MANUAL_IMPORT = "BILLINGS/create_record_manual_import";
export const UPDATE_RECORD_MANUAL_IMPORT = "BILLINGS/update_record_manual_import";
export const UPDATE_AMOUNT_FEES_BORONGAN = "BILLINGS/update_amount_fees_borongan";
export const DELETE_RECORD_MANUAL_IMPORT = "BILLINGS/delete_record_manual_import";

// Borongan - penalty and discount calculation api
export const CALCULATE_PENALTY_DISCOUNT = "CALCULATE_PENALTY_DISCOUNT/calculate_penalty_discount"
// Payment Billing
export const GET_PAYMENT_LIST = "BILLINGS/get_payment_list";
export const VIEW_PAYMENT_LISTING = 'VIEW_PAYMENT_LISTING/view_payment_listing';
export const UPDATE_OR_NUMBER = 'UPDATE_OR_NUMBER/update_or_number'

export const RPTAX_BILLING_EOR_URL = 'api/v1/administrators/real_property_tax_billings/{id}/preview_or';

export const SELECT_QUARTER = [
  { label: 'First Quarter', value: '1st' },
  { label: 'Second Quarter', value: '2nd' },
  { label: 'Third Quarter', value: '3rd' },
  { label: 'Fourth Quarter', value: '4th' },
];

export const PROPERTY_KINDS = [
  {label: 'LAND', value: 'LAND'},
  {label: 'BUILDING', value: 'BUILDING'},
  {label: 'MACHINERY', value: 'MACHINERY'},
]

export const CLASSIFICATIONS = [
  {label: 'RESIDENTIAL', value: 'RESIDENTIAL'},
  {label: 'AGRICULTURAL', value: 'AGRICULTURAL'},
  {label: 'COMMERCIAL', value: 'COMMERCIAL'},
  {label: 'INDUSTRIAL', value: 'INDUSTRIAL'},
  {label: 'MINERAL', value: 'MINERAL'},
  {label: 'TIMBERLAND', value: 'TIMBERLAND'},
];

export const INITIAL_FORMDATA = {
    // tdn: '',
    // pin: '',
    // year: '',
    // account_number: '',
    // account_name: '',
    // date_processed: '',
    // expiration_date: '',
    // amount: '',
    // is_delinquent: 0,
    // is_overwrite: 0,


    tdn: '',
    pin: '',
    account_number: '',
    account_name: '',
    period_covered_from: '',
    // period_covered_to: '',
    year: '',
    owner_name: '',
    location_region: '',
    location_province: '',
    location_municipality: '',
    location_barangay: '',
    location_district: '',
    location_zone: '',
    location_street: '',
    area: '',
    oct_tct_cloa_no: '',
    survey_no: '',
    lot_no: '',
    block_no: '',
    kind_of_property: '',
    classification: '',
    special_class: '',
    boundaries_north: '',
    boundaries_south: '',
    boundaries_east: '',
    boundaries_west: '',
    first_quarter: '',
    second_quarter: '',
    third_quarter: '',
    fourth_quarter: '',
    total_amount: '',
    co_owners: [],
    values: [
      {
        type: '',
        assessed_value: 0,
        tax_due: 0,
        penalty: 0,
        discount: 0,
        total_amount: 0,
      },
      { // duplicate key obj key for demo purpose only
        type: '',
        assessed_value: 0,
        tax_due: 0,
        penalty: 0,
        discount: 0,
        total_amount: 0,
      }
    ],
}

export const INITIAL_FORMDATA_BORONGAN = {
  tdn: '',
  pin: '',
  account_number: '',
  account_name: '',
  period_covered_from: '',
  year: '',
  owner_name: '',
  location_region: '',
  location_province: '',
  location_municipality: '',
  location_barangay: '',
  location_district: '',
  location_zone: '',
  location_street: '',
  area: '',
  oct_tct_cloa_no: '',
  survey_no: '',
  lot_no: '',
  block_no: '',
  kind_of_property: '',
  classification: '',
  special_class: '',
  boundaries_north: '',
  boundaries_south: '',
  boundaries_east: '',
  boundaries_west: '',
  first_quarter: '',
  second_quarter: '',
  third_quarter: '',
  fourth_quarter: '',
  total_amount: '',
  co_owners: [],

  assessed_value: '',
  tax_due: '',
  penalty: '',
  discount: '',
  gross_total: '',
}

export const AMOUNT_FORMDATA = {
  type: '',
  assessed_value: 0,
  tax_due: 0,
  penalty: 0,
  discount: 0,
  total_amount: 0,
}

export const CO_OWNER_FORMDATA = { name: ''}